<p-confirmDialog #dialog [key]="key">
	<!-- Lucide icon of the confirmation (its `icon` option holds a lucide name), same box as PrimeNG's default -->
	<ng-template #icon>
		@if (dialog.option('icon'); as iconName) {
			<lucide-icon [name]="iconName" class="p-confirmdialog-icon icon-em"></lucide-icon>
		}
	</ng-template>
</p-confirmDialog>
